{
    "PasswordChange_Title": "Wachtwoord wijzigen",
    "PasswordChange_SubTitle": "Voer je huidige wachtwoord in, je nieuwe gewenste wachtwoord (minimaal {} tekens vereist) en je nieuwe wachtwoord om de nieuwe waarde te bevestigen.",
    "PasswordChange_Fields_OldPassword": "Huidig wachtwoord",
    "PasswordChange_Fields_NewPassword": "Nieuw wachtwoord",
    "PasswordChange_Fields_ConfirmPassword": "Nieuw wachtwoord bevestigen",
    "PasswordChange_Validations_PasswordsMustMatch": "Wachtwoorden komen niet overeen",
    "PasswordChange_Validations_CurrentRequired": "Huidig wachtwoord vereist",
    "PasswordChange_Validations_NewRequired": "Nieuw wachtwoord vereist",
    "PasswordChange_Validations_ConfirmRequired": "Wachtwoord bevestigen vereist",
    "PasswordChange_Actions_ChangePassword": "Wachtwoord wijzigen",
    "PasswordChange_Actions_Cancel": "Annuleren",
    "NAME": "PasswordChangeLanguage",
    "PasswordReset_Title": "Wachtwoord opnieuw instellen",
    "PasswordReset_SubTitle": "Voer uw nieuwe gewenste wachtwoord in (minimaal {} tekens vereist), en voer uw nieuwe wachtwoord nogmaals in om de nieuwe waarde te bevestigen.",
    "PasswordReset_Success": "U hebt het wachtwoord voor uw gebruikersaccount succesvol bijgewerkt. \n \n Klik op de knop **Doorgaan**. U keert dan terug naar de welkomstpagina. Daar kunt u ook op de link 'Aanmelden' klikken om toegang te krijgen tot uw account.",
    "PasswordChange_Actions_Continue": "Doorgaan"
}